import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const LockIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M4.667 6.667a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h6.666a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H4.667ZM8 .667A3.333 3.333 0 0 0 4.667 4v1.333a.667.667 0 1 0 1.333 0V4a2 2 0 1 1 4 0v1.333a.667.667 0 0 0 1.333 0V4A3.333 3.333 0 0 0 8 .667Z", fill: "currentColor" })));
});
LockIcon.displayName = 'LockIcon';
export default LockIcon;
